
import Vue from 'vue';
import Hls from 'hls.js';
import {mapState} from 'vuex';
import EventService from '@/services/EventService';
import store from '../store';
import type {User} from 'firebase/auth';

type Data = {
  videoLoaded: boolean;
  soundVolume: number;
  reverse: boolean;
  current: Level;
  levels: Array<Level>;
  hls?: Hls;
};

type Method = {
  loadeddata(): void;
  timeupdate(): void;
  changeLevel(level: number): void;
};

type Computed = {
  videoEle: HTMLMediaElement;
  nodeEle: HTMLMediaElement;
  user: User | undefined;
};

type Props = {
  trainingID: string;
};

type Level = {
  text: string;
  value: number;
};

type OriginalLevelObj = {
  width: number;
  height: number;
  bitrate: number;
};

export default Vue.extend<Data, Method, Computed, Props>({
  name: 'temp',
  computed: {
    videoEle(): HTMLMediaElement {
      return this.$refs.video as HTMLMediaElement;
    },
    nodeEle(): HTMLMediaElement {
      return this.$refs.waitOnMe as HTMLMediaElement;
    },
    ...mapState(['user']),
  },
  props: {
    trainingID: {
      type: String,
    },
  },

  data: (): Data => ({
    // when it is true, controller should be enable
    videoLoaded: false,
    soundVolume: 0,
    reverse: true,
    current: {text: '自動', value: -1},
    levels: [{text: '自動', value: -1}],
    // mounted で作成した変数を methods で参照用
    hls: undefined,
  }),

  watch: {
    soundVolume: function (val) {
      this.videoEle.volume = val / 100;
    },
  },
  methods: {
    loadeddata: function () {
      this.videoEle.currentTime = 0;
      this.videoLoaded = true;
      this.nodeEle.load();
    },
    timeupdate: function () {
      const video = this.videoEle;
      const now = video.currentTime;
      const duration = video.duration;
      // watch the video to the last three seconds it will have been seen
      if (now > duration - 3) {
        this.$emit('played');
      }
    },
    changeLevel: function (level: number) {
      if (this.hls) {
        this.hls.currentLevel = level;
      }
    },
  },
  async mounted() {
    const video = this.videoEle;
    const levelSelect = this.levels;
    if (Hls.isSupported() && this.user) {
      const token = await this.user.getIdToken();
      this.videoLoaded = false;
      const hls = new Hls({
        xhrSetup: function (xhr) {
          const companyID = store.state.current;
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
          xhr.setRequestHeader('x-company-id', companyID);
        },
      });

      hls.loadSource(
        `${EventService.ProtoURL()}/hls/cfd/00004/${this.trainingID}.m3u8`
      );
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function (eventName, data) {
        // levels は interface manifestParsedData 内 で number[] と定義されているが、実際は Object[]
        const {levels} = data;
        const levelObjects: Array<OriginalLevelObj> = levels as any;
        levelObjects.forEach((level, i) => {
          levelSelect.push({text: `${level.height}p`, value: i});
        });
      });
      hls.currentLevel = this.current.value;
      this.hls = hls;

      video.volume = 0.3;
      const vv = video.volume;

      this.soundVolume = vv * 100;
    }
  },
});
